// removed by extract-text-webpack-plugin
module.exports = {"Left":"Left__1XV9W","Right":"Right__IQ1ZQ","FooterButton":"FooterButton__2mmsj","FooterButtonImg":"FooterButtonImg__hiaKL","FooterButtonText":"FooterButtonText__2aPVw","UnreadDotContainer":"UnreadDotContainer__b_1EX","UnreadDot":"UnreadDot__2A8a8"};


//////////////////
// WEBPACK FOOTER
// ./routes/Footer/FooterButton/style.scss
// module id = LIe4
// module chunks = 0